var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDeezer = function SvgDeezer(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H16.5403V9.02419H20V7Z",
    fill: "#40AB5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.80646H16.5403V11.8307H20V9.80646Z",
    fill: "url(#paint0_linear_291:284)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.6129H16.5403V14.6371H20V12.6129Z",
    fill: "url(#paint1_linear_291:284)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45968 15.4194H4V17.4436H7.45968V15.4194Z",
    fill: "url(#paint2_linear_291:284)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 15.4194H8.17742V17.4436H11.6371V15.4194Z",
    fill: "url(#paint3_linear_291:284)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8226 15.4194H12.3629V17.4436H15.8226V15.4194Z",
    fill: "url(#paint4_linear_291:284)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.4194H16.5403V17.4436H20V15.4194Z",
    fill: "url(#paint5_linear_291:284)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8226 12.6129H12.3629V14.6371H15.8226V12.6129Z",
    fill: "url(#paint6_linear_291:284)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 12.6129H8.17742V14.6371H11.6371V12.6129Z",
    fill: "url(#paint7_linear_291:284)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6371 9.80646H8.17742V11.8307H11.6371V9.80646Z",
    fill: "url(#paint8_linear_291:284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_291:284",
    x1: 18.2871,
    y1: 11.8481,
    x2: 18.2546,
    y2: 9.77674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#358C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#33A65E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_291:284",
    x1: 16.4895,
    y1: 14.5332,
    x2: 20.0524,
    y2: 12.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_291:284",
    x1: 4.00063,
    y1: 16.4323,
    x2: 7.45742,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_291:284",
    x1: 8.18127,
    y1: 16.4323,
    x2: 11.6381,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_291:284",
    x1: 12.3619,
    y1: 16.4323,
    x2: 15.8187,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_291:284",
    x1: 16.5385,
    y1: 16.4323,
    x2: 19.9952,
    y2: 16.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_291:284",
    x1: 12.2255,
    y1: 14.1708,
    x2: 15.9551,
    y2: 13.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_291:284",
    x1: 8.05823,
    y1: 12.9516,
    x2: 11.7611,
    y2: 14.2993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CE1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_291:284",
    x1: 8.47182,
    y1: 9.49188,
    x2: 11.3475,
    y2: 12.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00266984,
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5A22"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDeezer);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";